<script setup lang="ts">
  import { Slider } from '@/shared/ui';

  interface Props {
    modelValue: number;
  }

  defineProps<Props>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: number): void;
  }>();

  const handleChange = (value: number[] | undefined) => {
    emit('update:modelValue', value?.[0] ?? 0);
  };
</script>

<template>
  <div class="spacing-slider">
    <div class="spacing-slider-header">
      <span class="spacing-label">Espaçamento</span>
      <span class="spacing-value">{{ modelValue }}px</span>
    </div>
    <Slider
      :model-value="[modelValue]"
      :min="0"
      :max="50"
      :step="1"
      class="spacing-slider-control"
      @update:model-value="handleChange"
    />
  </div>
</template>

<style scoped>
  .spacing-slider {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    min-width: 160px;
  }

  .spacing-slider-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .spacing-label {
    font-size: 12px;
    color: var(--color-gray-05);
  }

  .spacing-value {
    font-size: 12px;
    color: var(--color-gray-07);
    font-weight: 500;
    min-width: 32px;
    text-align: right;
  }

  .spacing-slider-control {
    width: 100%;
  }
</style>
